export default [
  {
    path: "/oportunidades",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "oportunidades_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Oportunidades", to: "oportunidades_list" }],
          permission: "oportunidade:view",
          title: "Oportunidades"
        }
      },
      {
        name: "oportunidades_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Oportunidades", to: "oportunidades_list" }],
          permission: "oportunidade:create",
          title: "Oportunidades - Cadastro"
        }
      },
      {
        name: "oportunidades_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Oportunidades", to: "oportunidades_list" }],
          permission: "oportunidade:edit",
          title: "Oportunidades - Edição"
        }
      }
    ]
  },
  {
    path: "/importar",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "oportunidades_import_select",
        path: "",
        component: () => import("./pages/Import"),
        meta: {
          breadcrumbs: [{ label: "Oportunidades", to: "oportunidades_list" }],
          permission: "oportunidade:edit",
          title: "Selecione o Recurso"
        }
      },
      {
        name: "oportunidades_import_emendas",
        path: "importar/emendas",
        component: () => import("./pages/ImportEmendas"),
        meta: {
          breadcrumbs: [{ label: "Oportunidades", to: "oportunidades_list" }],
          permission: "oportunidade:edit",
          title: "Importar Recursos"
        }
      }
    ]
  }
];
